import { createApp } from 'vue'; // Import createApp from Vue 3
import store from './store/store'; // Import Vuex 4 store
import Map from './Map.vue';       // Import the root component

// Import CSS and libraries used globally or by Map.vue initialization
import mapboxgl from 'mapbox-gl'; // mapbox-gl might be needed globally or passed

// Global properties declaration (still used by Map.vue or other parts)
// Note: window.vue is removed as it's not applicable in Vue 3's app model.
declare global {
  interface Window {
    map: mapboxgl.Map; // Global map instance (used by helpers/Map.vue)
    typesenseUrl: string;
    typesenseSearchApiKey: string;
    country_id: number | null;
    region_id: number | null;
    mapReady: Function; // Assuming this is set elsewhere
    user?: any; // Assuming this is set elsewhere (e.g., via backend template)
    onBoardingVue?: { launchFor: (goal: any) => void }; // Define launchFor shape
    // window.bus is removed - use Vuex or other state management instead
  }
}

// Find the mounting point
const mountElement = document.querySelector('#main_map');

if (mountElement) {
  // Create the Vue 3 application instance with Map as the root component
  const app = createApp(Map);

  // Use the Vuex store plugin
  app.use(store);

  // Mount the application to the DOM element
  app.mount('#main_map');

} else {
  console.error("Mount element #main_map not found.");
}
